import { ref, watch } from 'vue';
import { defineStore } from 'pinia';
import { cloneDeep } from 'lodash';
import { instance as requestInstance } from '@client/helper/http';
import Definition from '@client/config/definition';
import { defaultExerciseConfigs } from '@client/components/programEdit/constants';

export const trainingProgramStore = defineStore('trainingProgram', () => {
  const exercises = ref([]);
  const isStrength = (sportType) => ['strength'].includes(Definition.sportCategoryName[sportType]);
  const isLoading = ref(false);
  let sportType = '';
  let teamId = '';
  let userId = '';

  const clearExercises = () => {
    exercises.value = [];
  };

  const getExercises = (_teamId, _userId, _sportType) => {
    // userId 一定要传
    let result;

    teamId = _teamId || teamId;
    userId = _userId || userId || undefined;
    sportType = _sportType || sportType;
    if (!userId) return;
    if (isStrength(sportType)) {
      isLoading.value = true;
      const options = {
        url: '/training/exercise/query',
        method: 'get',
        params: {
          teamId,
          userId,
          sportType
        }
      };

      result = requestInstance
        .request(options)
        .then((resData) => {
          const data = resData.data || [];
          data.sort((a, b) => {
            return a.sortNo - b.sortNo;
          });
          exercises.value = data;
          return exercises.value;
        })
        .catch((err) => {
          console.error(err);
        });
    } else {
      exercises.value = cloneDeep(defaultExerciseConfigs[Definition.sportCategoryName[sportType]] || []);
      result = Promise.resolve(exercises.value);
    }

    return result;
  };

  return {
    exercises,
    isLoading,
    getExercises,
    clearExercises
  };
});
